export default class Trash extends Phaser.Sprite {
    constructor (game, x, y, key) {
        super(game, x, y, key)
    }
}



/** WEBPACK FOOTER **
 ** ./scripts/game_objects/Trash.js
 **/